const SuggestionCard = {
	comments: ' Comments'
}

export default SuggestionCard;